define("shared/utils/focus", ["exports", "@ember/runloop"], function (_exports, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = focus;
  0; //eaimeta@70e063a35619d71f0,"@ember/runloop"eaimeta@70e063a35619d71f
  function focus(elemOrString) {
    (0, _runloop.next)(() => {
      const element = typeof elemOrString === 'string' ? document.querySelector(elemOrString) : elemOrString;
      if (element instanceof HTMLElement) {
        element.focus();
      }
    });
  }
});